export default __webpack_public_path__ + "static/media/coinbase-wallet-dot.9b80f33e.svg";